<div class="overlay-container">
  <div class="overlay-header flex flex-row justify-between items-center lt-md:items-start">
    <div class="flex flex-row flex-wrap gap-[12px] justify-start items-center">
      <h1>
        {{ '+INSTALLATIONS.INSTALLATION.REMOTE_SERVICE' | translate }}
      </h1>
      <ng-container *ngIf="isMaintainerWithFreeOrBasicOrPlusPackage">
        <div class="installation-package">
          <span
            [matTooltip]="'+REMOTE_SERVICE.BASIC_PACKAGE_TOOLTIP' | translate"
            matTooltipPosition="above"
          >
            {{ '+BOOKING.PLAN.BASIC_PACKAGE' | translate }}
          </span>
        </div>
      </ng-container>
    </div>
    <button
      gtm="onRemoteServiceOverlay"
      gtmAction="Close overlay"
      gtmCategory="Remote Service overlay"
      data-at-close-overlay-btn
      mat-stroked-button
      class="close-btn-overlay lt-md:!hidden"
      (click)="closeOverlay()"
    >
      <span>{{ '+INSTALLATIONS.INSTALLATION.OVERLAY.CLOSE_BUTTON' | translate }}</span>
      <mat-icon iconPositionEnd>close</mat-icon>
    </button>
    <button
      gtm="onRemoteServiceOverlay"
      gtmAction="Close overlay"
      gtmCategory="Remote Service overlay"
      data-at-close-overlay-btn
      mat-icon-button
      class="close-btn-small !hidden lt-md:!inline-flex"
      (click)="closeOverlay()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <ng-container
    *ngrxLet="
      remoteServiceStore.remoteServiceDiagnosisLoadingStatus$ as remoteServiceDiagnosisLoadingStatus
    "
  >
    <app-devices-list
      [devicesList$]="devicesStore.mainAndLagDevices$"
      [disabled]="
        remoteServiceDiagnosisLoadingStatus === RemoteServiceDiagnosisLoadingStatus.DataLoading
      "
      data-at-installation-devices-list
    ></app-devices-list>
  </ng-container>

  <app-remote-service-tabs [activeOverlay]="activeOverlay"></app-remote-service-tabs>

  <div class="overlay-body flex flex-col gap-[30px]">
    <ng-container [ngSwitch]="activeOverlay">
      <div
        class="notification-banner"
        *ngIf="remoteServiceStore.isLowBudgetNotificationVisible$ | async"
      >
        <app-banner
          linkGtmAction="Close banner"
          linkGtmCategory="permanentInspection"
          [linkLabel]="'+REMOTE_INSPECTION.BANNER.LOW_BUDGET_ACTION' | translate"
          (clickEvent)="hideLowBudgetNotification()"
          [linkInNewLine]="true"
        >
          {{ '+REMOTE_INSPECTION.BANNER.LOW_BUDGET_DESCRIPTION' | translate }}
        </app-banner>
      </div>
      <ng-container *ngSwitchCase="RemoteServiceOverlayTypeEnum.Anomalies">
        <app-remote-service-diagnosis
          [diagnosisList]="anomalyList$ | async"
          [type]="'anomaly'"
        ></app-remote-service-diagnosis>
        <app-information-popup
          [page]="InformationPopupPage.RemoteServiceAnomalies"
        ></app-information-popup>
      </ng-container>
      <ng-container *ngSwitchCase="RemoteServiceOverlayTypeEnum.Diagnosis">
        <app-remote-service-diagnosis
          [diagnosisList]="diagnosisList"
          [type]="'diagnosis'"
        ></app-remote-service-diagnosis>
        <app-information-popup
          [page]="InformationPopupPage.RemoteServiceDiagnosis"
        ></app-information-popup>
      </ng-container>
      <ng-container *ngSwitchCase="RemoteServiceOverlayTypeEnum.Features">
        <app-remote-service-features></app-remote-service-features>
        <app-information-popup
          [page]="InformationPopupPage.RemoteServiceFeatures"
        ></app-information-popup>
      </ng-container>
      <ng-container *ngSwitchCase="RemoteServiceOverlayTypeEnum.Report">
        <app-remote-service-report></app-remote-service-report>
        <app-information-popup
          [page]="InformationPopupPage.RemoteServiceReport"
        ></app-information-popup>
      </ng-container>
    </ng-container>
  </div>
</div>
